module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "vbl-multi-option",
    class: _vm.classes,
    on: {
      "click": function($event) {
        _vm.onChange(!_vm.isChecked)
      }
    }
  }, [_c('span', {
    staticClass: "selected-icon"
  }), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc77d80a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblSelect/src/vblMultiOption.vue
// module id = 294
// module chunks = 0